import { render, staticRenderFns } from "./bonus-points-preview.vue?vue&type=template&id=392cc24e&scoped=true&"
import script from "./bonus-points-preview.vue?vue&type=script&lang=js&"
export * from "./bonus-points-preview.vue?vue&type=script&lang=js&"
import style0 from "./bonus-points-preview.vue?vue&type=style&index=0&id=392cc24e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392cc24e",
  null
  
)

export default component.exports